/**
 * How a non-slot document reads on the case's Documents tab (T-108).
 *
 * The drop-off portal (Brampton VC / Ajax) files extra paperwork under a short
 * list of types, plus "Other" with a name the facility typed. Those rows land
 * in "Uploaded Documents" here; without this they read as bare filenames
 * ("IMG_4471.jpg") and staff cannot tell a coroner's release from an ID.
 */

/** Types the drop-off portal can file that have no slot of their own. */
export const EXTRA_DOCUMENT_TYPE_LABELS: Record<string, string> = {
  coroner_release: "Coroner's warrant / release",
  identification: 'ID / Proof of identity',
  belongings_list: 'Belongings list',
  other: 'Other document',
};

export interface LabelledDocument {
  document_type: string;
  label?: string | null;
  original_filename?: string | null;
  uploaded_by?: string | null;
}

/** "Coroner's warrant / release", "Other: Hospital release form", or the filename. */
export function extraDocumentTitle(doc: LabelledDocument): string {
  const label = doc.label?.trim();
  const typeLabel = EXTRA_DOCUMENT_TYPE_LABELS[doc.document_type];
  if (doc.document_type === 'other') {
    if (label) return `Other: ${label}`;
    return doc.original_filename || 'Document';
  }
  if (typeLabel) return label ? `${typeLabel}: ${label}` : typeLabel;
  return doc.original_filename || 'Document';
}

/** "Uploaded by Brampton VC", or null for staff uploads (no uploader recorded). */
export function uploadedByLine(doc: Pick<LabelledDocument, 'uploaded_by'>): string | null {
  const who = doc.uploaded_by?.trim();
  return who ? `Uploaded by ${who}` : null;
}
